import { ResponsiveDimension } from "../../../../types";
import { ButtonFill } from "../types";

export default function getBorderStyleProps(fill: ButtonFill) {
  return fill === "outlined"
    ? {
        borderWidth: "none" as ResponsiveDimension,
        borderRadius: "small" as ResponsiveDimension,
        boxShadow: "0 0 0 2px inset"
      }
    : {
        borderWidth: "none" as ResponsiveDimension,
        borderRadius: "small" as ResponsiveDimension
      };
}
